import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "relative p-10 w-full min-h-screen" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-4xl leading-10 font-extrabold mb-10" }, "Your credit box", -1)
const _hoisted_3 = {
  key: 0,
  class: "flex flex-wrap"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "w-1/2 lg:1/3 pr-2 relative max-w-xs" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "$")
], -1)
const _hoisted_7 = { class: "w-1/2 lg:1/3 pr-2 relative max-w-xs" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "$")
], -1)
const _hoisted_9 = { class: "w-1/2 pr-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "firstName",
  class: "block text-sm font-medium text-gray-700"
}, " First name ", -1)
const _hoisted_11 = { class: "mt-1" }
const _hoisted_12 = { class: "w-1/2 pl-1" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "lastName",
  class: "block text-sm font-medium text-gray-700"
}, " Last name ", -1)
const _hoisted_14 = { class: "mt-1" }
const _hoisted_15 = { class: "w-1/2 pr-1 mt-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-sm font-medium text-gray-700"
}, " Corporate email ", -1)
const _hoisted_17 = { class: "mt-1" }
const _hoisted_18 = { class: "w-1/2 pl-1 mt-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "block text-sm font-medium text-gray-700"
}, " Phone ", -1)
const _hoisted_20 = { class: "mt-1" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 1,
  class: "flex flex-wrap"
}
const _hoisted_23 = { class: "py-2 px-4 rounded-md mr-2 mb-2 cursor-pointer text-sm bg-blue-200 text-sky" }
const _hoisted_24 = { class: "py-2 px-4 rounded-md mr-2 mb-2 cursor-pointer text-sm bg-blue-200 text-sky" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Map = _resolveComponent("Map")!
  const _component_ArrowNarrowDownIcon = _resolveComponent("ArrowNarrowDownIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleSteps, ({
        title, options, isActive, isCompleted, nextStep, type
      }, key) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["block p-6 rounded-md shadow-sm bg-white mb-4 max-w-5xl", { 'pointer-events-none opacity-20': !isActive }]),
        key: key
      }, [
        _createElementVNode("h3", {
          class: _normalizeClass({
          'text-lg leading-6 font-medium mb-4': isCompleted,
          'text-xl leading-7 font-medium mb-6': !isCompleted
        })
        }, _toDisplayString(title), 3),
        (isActive && !isCompleted)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (type !== 'map')
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    (type == 'selector')
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(options, (option, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["py-2 px-5 border rounded-md mr-2 mb-2 cursor-pointer", { 'bg-gray-200 border-gray-200': _ctx.steps[key].collectedData && _ctx.steps[key].collectedData.has(option) }]),
                            key: index,
                            onClick: ($event: any) => (_ctx.updateValue(key, option))
                          }, _toDisplayString(option), 11, _hoisted_4))
                        }), 128))
                      : _createCommentVNode("", true),
                    (type == 'loanAmountRange')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", _hoisted_5, [
                            _hoisted_6,
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "border rounded-md h-10 w-full text-sm px-3 pl-6",
                              id: "minimumAmount",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.steps.loanAmount.collectedData.minimumAmount) = $event)),
                              placeholder: " Minimum amount"
                            }, null, 512), [
                              [_vModelText, _ctx.steps.loanAmount.collectedData.minimumAmount]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_7, [
                            _hoisted_8,
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "border rounded-md h-10 w-full text-sm px-3 pl-6",
                              id: "maximumAmount",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.steps.loanAmount.collectedData.maximumAmount) = $event)),
                              placeholder: " Maximum amount"
                            }, null, 512), [
                              [_vModelText, _ctx.steps.loanAmount.collectedData.maximumAmount]
                            ])
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                    (type == 'contacts')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("div", _hoisted_9, [
                            _hoisted_10,
                            _createElementVNode("div", _hoisted_11, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "firstName",
                                id: "firstName",
                                class: "focus:ring-indigo-500 focus:border-indigo-500 block w-full border rounded-md h-10 w-full text-sm px-3",
                                placeholder: "David",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.steps.contacts.collectedData.firstName) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.steps.contacts.collectedData.firstName]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _hoisted_13,
                            _createElementVNode("div", _hoisted_14, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "lastName",
                                id: "lastName",
                                class: "focus:ring-indigo-500 focus:border-indigo-500 block w-full border rounded-md h-10 w-full text-sm px-3",
                                placeholder: "Miller",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.steps.contacts.collectedData.lastName) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.steps.contacts.collectedData.lastName]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _hoisted_16,
                            _createElementVNode("div", _hoisted_17, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "email",
                                id: "email",
                                class: "focus:ring-indigo-500 focus:border-indigo-500 block w-full border rounded-md h-10 w-full text-sm px-3",
                                placeholder: "david.miller@company.com",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.steps.contacts.collectedData.email) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.steps.contacts.collectedData.email]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _hoisted_19,
                            _createElementVNode("div", _hoisted_20, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "phone",
                                id: "phone",
                                class: "focus:ring-indigo-500 focus:border-indigo-500 block w-full border rounded-md h-10 w-full text-sm px-3",
                                placeholder: "(305) 264-43-33",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.steps.contacts.collectedData.phone) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.steps.contacts.collectedData.phone]
                              ])
                            ])
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (type == 'map')
                ? (_openBlock(), _createBlock(_component_Map, {
                    key: 1,
                    onUpdated: _cache[6] || (_cache[6] = ($event: any) => (_ctx.steps.workingArea.collectedData = $event))
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: _normalizeClass(["h-10 bg-sky text-white rounded-md w-24 mt-4 flex justify-center items-center", { 'pointer-events-none opacity-50': !_ctx.validSteps[key], 'mt-6': ['contacts', 'loanAmountRange'].includes(type) }]),
                onClick: ($event: any) => (_ctx.processNextStep(key, nextStep))
              }, [
                _createTextVNode(_toDisplayString(type == 'contacts' ? 'Submit': 'Next') + " ", 1),
                (type !== 'contacts')
                  ? (_openBlock(), _createBlock(_component_ArrowNarrowDownIcon, {
                      key: 0,
                      class: "w-4 h-4 ml-3 -mr-1"
                    }))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_21)
            ], 64))
          : _createCommentVNode("", true),
        isCompleted
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              (type == 'selector' || type == 'map')
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(Array.from(_ctx.steps[key].collectedData), (option, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "py-2 px-4 rounded-md mr-2 mb-2 cursor-pointer text-sm bg-blue-200 text-sky",
                      key: index
                    }, _toDisplayString(option), 1))
                  }), 128))
                : _createCommentVNode("", true),
              (type == 'loanAmountRange')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_23, " From $" + _toDisplayString(_ctx.convertToShortCurrency(_ctx.steps.loanAmount.collectedData.minimumAmount)), 1),
                    _createElementVNode("div", _hoisted_24, " To $" + _toDisplayString(_ctx.convertToShortCurrency(_ctx.steps.loanAmount.collectedData.maximumAmount)), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 2))
    }), 128))
  ]))
}